import React from 'react'
import AutomationRules from 'src/app/AutomationRules/AutomationRules'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { automationRulesRouteProps } from 'src/navigation/routeProps'

const AutomationRulesAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsAutomationRules,
  routeProps: automationRulesRouteProps,
  component: <AutomationRules />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default AutomationRulesAppRoute
